import { secureGet, securePost, secureDelete } from "../../Config/ApiConfig";

/**
 * Request a new data export
 * @returns {Promise} - The created export with its ID for tracking progress
 */
export const requestDataExport = async () => {
    const { data } = await securePost('/data-exports', {});
    return data;
};

/**
 * Get the list of previous data exports with pagination
 * @param {Object} params - Pagination parameters
 * @param {number} params.page - Page number
 * @param {number} params.page_size - Number of items per page
 * @returns {Promise} - List of exports and pagination metadata
 */
export const getPreviousExports = async ({ page, page_size, filters, sort_by, sort_direction, search_string }) => {
    let url = `/data-exports?page=${page}&page_size=${page_size}`;
    if (filters && Object.keys(filters).length > 0) {
        url += `&filters=${encodeURIComponent(JSON.stringify(filters))}`;
    }
    if (typeof search_string === 'string' && search_string.trim() !== '') {
        url += `&search_string=${encodeURIComponent(search_string)}`;
    }
    if (sort_by) {
        url += `&sort_by=${encodeURIComponent(String(sort_by))}`;
        if (sort_direction) {
            url += `&sort_direction=${encodeURIComponent(String(sort_direction))}`;
        }
    }
    const { data } = await secureGet(url);
    return data;
};

/**
 * Delete a data export
 * @param {string} exportId - ID of the export to delete
 * @returns {Promise} - Result of the deletion operation
 */
export const deleteExport = async (exportId) => {
    const { data } = await secureDelete(`/data-exports/${exportId}`);
    return data;
};

/**
 * Update consent preferences
 * @param {Object} consents - Consent settings
 * @returns {Promise} - Updated consent information
 */
export const updateConsents = async (consents) => {
    const { data } = await securePost('/settings/consents', consents);
    return data;
};

/**
 * Delete the current user's account
 * @returns {Promise} - Result of the account deletion operation
 */
export const deleteAccount = async () => {
    const { data } = await secureDelete('/users/me');
    return data;
};